<template>
    

    <div id="canvas1" width="600" height="600" style="width: 100%; height: auto;" class="q-mb-md">
        <svg id="svg" width="600" height="600" viewBox="0 0 600 600" preserveAspectRatio="xMidYMid meet" >
            <g  v-for="tela in telas" :key="tela.id">
                <e-rect v-if="tela.type=='rect'" :tela="tela" @click="seleccionar_sector(tela.identificador)"></e-rect>
                <e-text v-if="tela.type=='text'" :tela="tela"></e-text>
                <e-path v-if="tela.type=='path'" :tela="tela" @click="seleccionar_sector(tela.identificador)"></e-path> 
                <e-image v-if="tela.type=='image'"  :tela="tela" :url="props.url"></e-image>
    
               
            </g>

            
        </svg>
    </div>
</template>
  
<script setup>
// @ is an alias to /src
import { useRouter } from "vue-router";
import { ref, defineEmits } from "vue";
import { useEPStore } from "@/store/store";
import EImage from "./MapComponents/Image.vue";
import EPath from "./MapComponents/Path.vue";
import ERect from "./MapComponents/Rect.vue";
import EText from "./MapComponents/Text.vue";
const emit = defineEmits(['seleccionar_sector_id'])
const store = useEPStore();
const router = useRouter();
const props = defineProps(["sectores", "mapa","url"]);
const dialog = ref(false);
const sectorActual = ref(null);
const cantidad_entradas = ref(1);
const loading = ref(false);
const errores = ref(false);
const mensaje = ref("");
const telas = ref(JSON.parse(props["mapa"]))
console.log(telas.value)

function seleccionar_sector(sectorId) {
// console.log("SADJASKLDJLSAKD"+sectorId)
  emit("seleccionar_sector_id",sectorId);
}
</script>

<style scoped>
#canvas1{
    max-width: 600px;
    max-height: 600px;
    min-width: 200px;
    min-height: 200px;
    border: 1px solid grey;
    border-radius: 6px;
    margin:auto;
    aspect-ratio: 1 / 1;
}

#svg{
    height: 100%;
    width: 100%;
    overflow: hidden;
    position: relative;
    left: -0.671875px;
}
</style>
  